import * as React from 'react';
import { Container } from '@mui/material';
import { NextSeo } from 'next-seo';

import Header from '../components/LandingPage/Header';
import Faq from '../components/LandingPage/Faq';
import PricingSection from '../components/LandingPage/PricingSection';
import Footer from '../components/LandingPage/Footer';
import ScrollToTop from '../components/LandingPage/Components/ScrollToTop';


export default function Pricing() {
    return (
        <>
            <NextSeo
                title="Scriptu Pricing | Transform Your LinkedIn Presence with AI"
                description="Discover Scriptu's affordable pricing plans. Transform your LinkedIn presence with AI-powered tools that craft, schedule, and optimize posts to boost engagement and save time. Choose a plan that fits your needs and start standing out on LinkedIn today."
                canonical="https://www.scriptu.io/pricing" // Add your canonical URL here
                openGraph={{
                    url: "https://www.scriptu.io/pricing", // It's also good to set the URL in openGraph
                    title: "Scriptu Pricing | Transform Your LinkedIn Presence with AI",
                    description: "Discover Scriptu's affordable pricing plans. Transform your LinkedIn presence with AI-powered tools that craft, schedule, and optimize posts to boost engagement and save time. Choose a plan that fits your needs and start standing out on LinkedIn today.",
                    images: [
                        {
                            url: "/logo-promo.png",
                            width: 2000,
                            height: 520,
                            alt: "Scriptu Logo",
                        },
                    ],
                    site_name: "Scriptu",
                }}
                twitter={{
                    handle: '@handle',
                    site: '@site',
                    cardType: 'summary_large_image',
                }}
                additionalLinkTags={[
                    {
                        rel: 'icon',
                        href: '/favicon.png',
                    },
                    {
                        rel: 'apple-touch-icon',
                        href: '/favicon.png',
                        sizes: '128x128',
                    },
                ]}
            />
            <div id="back-to-top-anchor"></div>
            <div style={{
                background: 'black',
                backgroundImage: 'url(/bg.jpg)',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center'
            }}>
                <div id="back-to-top-anchor"></div>
                <Header />
            </div>
            <Container maxWidth="lg" sx={{ mt: 3, mb: 6 }}>
                <PricingSection />
                <Faq />
            </Container>
            <Footer />
            <ScrollToTop />
        </>
    );
}
